import { selectPlaceholderNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';

const KRC_REFERENCE_FRAME: BuildingBlockNodeConfig = {
  nodeSelector: selectPlaceholderNode,
  information: {
    single: 'Ordeningskader',
    plural: 'Ordeningskaders',
  },
  buildingBlocks: [{ type: NodeType.KRC_GOAL_SET }],
  edit: [],
  showPlaceholder: true,
  readOnlyNode: true,
  isNotDraggable: true,
  isNotDeletable: true,
  isCollapsible: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default KRC_REFERENCE_FRAME;
